import { render, staticRenderFns } from "./heyue.vue?vue&type=template&id=6c957998&scoped=true&"
import script from "./heyue.vue?vue&type=script&lang=js&"
export * from "./heyue.vue?vue&type=script&lang=js&"
import style0 from "./heyue.vue?vue&type=style&index=0&id=6c957998&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c957998",
  null
  
)

export default component.exports